import React from "react";

class Tooltip extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            style: {
                //backgroundColor: "blue",
                fontWeight: "bold",
                cursor:"pointer",
                //float:"right",
                borderRadius:"50%",
                height:"20px",
                width:"20px",
                fontStyle:"italic",
                border:"1px solid grey",
                textAlign:"center",
                padding:0,
                fontFamily: "serif"
            },
            ident: "tip"
        }
    }
    render() {
        return (
            <div className={this.state.ident}>

                <p style={this.state.style} title={"What you get in a full application: " + this.props.tip}>i</p>

            </div>
        )
    }
}

export default Tooltip;


// WEBPACK FOOTER //
// ./src/tooltip.js